const API_STATUS_CODE = {
  success: 200,
  movedPermanently: 301,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  downloadFail: 406,
  outdated: 426,
  serverError: 500,
  timeout: 'ECONNABORTED',
} as const;

const API_ERROR_MESSAGES = {
  noInternet:
    'サーバー側に接続できません。通信環境を確認の上、再度お試しください。',
  [API_STATUS_CODE.unauthorized]: 'ユーザー認証に失敗しました。',
  [API_STATUS_CODE.forbidden]: 'アクセスできません。',
  [API_STATUS_CODE.notFound]: 'ページが見つかりません。',
  [API_STATUS_CODE.serverError]: 'サーバーエラーが発生しました。',
  [API_STATUS_CODE.downloadFail]: 'ダウンロードが失敗しました。',
  [API_STATUS_CODE.timeout]:
    '時間がかかりすぎたため、接続が中断されました。再度お試しください。',
  [API_STATUS_CODE.outdated]:
    'キャッシュクリアのため、画面をリロードしてください',
} as Record<string | number, string>;

export { API_ERROR_MESSAGES, API_STATUS_CODE };
